import React from "react";
import {
  Creatable as ReactSelectCreatable,
  components,
} from "react-select";

export const getCreatableActionText = (data, inputValue) => {
  if (!String(inputValue || "").trim()) return "";
  return data && data.__isNew__ ? "để tạo mới" : "để chọn";
};

export const getCreatableClassName = (className = "") =>
  [className, "react-select", "vmass-creatable-select"]
    .filter(Boolean)
    .join(" ");

const normalizeCreatableValue = (value) =>
  String(value === undefined || value === null ? "" : value)
    .trim()
    .toLowerCase();

export const isCreatableOptionMatch = (data, inputValue, selectProps = {}) => {
  const normalizedInput = normalizeCreatableValue(inputValue);
  if (!normalizedInput || !data || data.__isNew__) return false;

  const optionLabel = selectProps.getOptionLabel
    ? selectProps.getOptionLabel(data)
    : data.label;
  const optionValue = selectProps.getOptionValue
    ? selectProps.getOptionValue(data)
    : data.value;

  return (
    normalizeCreatableValue(optionLabel) === normalizedInput ||
    normalizeCreatableValue(optionValue) === normalizedInput
  );
};

export const CreatableOption = (props) => {
  const { children, className, data, isFocused, selectProps } = props;
  const isNewOption = Boolean(data && data.__isNew__);
  const isMatchedOption = isCreatableOptionMatch(
    data,
    selectProps && selectProps.inputValue,
    selectProps,
  );
  const optionStateClassName = isNewOption
    ? "vmass-creatable-option-state--new"
    : isMatchedOption
      ? "vmass-creatable-option-state--matched"
      : "";
  const actionText = isFocused
    ? getCreatableActionText(data, selectProps && selectProps.inputValue)
    : "";

  return (
    <components.Option
      {...props}
      className={[className, optionStateClassName].filter(Boolean).join(" ")}
    >
      <span
        className={`vmass-creatable-option${
          isNewOption ? " vmass-creatable-option--new" : ""
        }`}
      >
        <span className="vmass-creatable-option__label">{children}</span>
        {actionText ? (
          <span className="vmass-creatable-option__hint">
            <kbd>Enter</kbd>
            <span>{actionText}</span>
          </span>
        ) : null}
      </span>
    </components.Option>
  );
};

const defaultFormatCreateLabel = (inputValue) => `Tạo mới: "${inputValue}"`;

const CreatableSelect = React.forwardRef(({
  className,
  classNamePrefix,
  components: customComponents,
  createOptionPosition,
  formatCreateLabel,
  ...props
}, ref) => (
  <ReactSelectCreatable
    ref={ref}
    {...props}
    className={getCreatableClassName(className)}
    classNamePrefix={classNamePrefix || "react-select"}
    components={{
      Option: CreatableOption,
      ...customComponents,
    }}
    createOptionPosition={createOptionPosition || "first"}
    formatCreateLabel={formatCreateLabel || defaultFormatCreateLabel}
  />
));
CreatableSelect.displayName = "CreatableSelect";

export default CreatableSelect;
